import { z } from 'zod';

const monthValue = z
	.string()
	.regex(/^\d{4}-\d{2}$/, 'Mês inválido');

export const MaintenanceSchema = z.object({
	name: z.string().trim().min(1, 'Identificação é obrigatória'),
	prop: z.string().min(1, 'Propriedade é obrigatória'),
	area: z.string().min(1, 'Área é obrigatória'),
	sectors: z.array(z.string()).min(1, 'Selecione pelo menos um setor'),
	soilAnalysis: z.string().min(1, 'Análise de solo é obrigatória'),
	plantingAdvice: z.string(),
	cropStage: z.enum(['growth', 'production', 'prune'], { error: 'Fase da lavoura é obrigatória' }),
	productivity: z.string(),
	parcellingType: z.enum(['fixed', 'dynamic'], { error: 'Esquema de parcelamento é obrigatório' }),
	parcelling: z.string().min(1, 'Parcelamento é obrigatório'),
	cycleStartMonth: z.string(),
	floweringMonth: z.string().min(1, 'Mês da florada é obrigatório'),
}).superRefine((data, ctx) => {
	if (data.parcellingType === 'fixed') {
		const cycleStart = Number(data.cycleStartMonth);
		if (!Number.isInteger(cycleStart) || cycleStart < 1 || cycleStart > 12) {
			ctx.addIssue({
				code: 'custom',
				path: ['cycleStartMonth'],
				message: 'Mês do início do ciclo é obrigatório',
			});
		}
	}

	if (!monthValue.safeParse(data.floweringMonth).success) {
		ctx.addIssue({
			code: 'custom',
			path: ['floweringMonth'],
			message: 'Mês da florada inválido',
		});
	}

	if (data.cropStage === 'growth') return;

	if (!data.productivity) return;

	const productivity = Number(data.productivity);
	if (!Number.isFinite(productivity)) {
		ctx.addIssue({
			code: 'custom',
			path: ['productivity'],
			message: 'Produtividade deve ser um número válido',
		});
	} else if (productivity <= 0) {
		ctx.addIssue({
			code: 'custom',
			path: ['productivity'],
			message: 'Produtividade deve ser maior que zero',
		});
	}
});

export const MaintenanceIdentificationSchema = z.object({
	name: z.string().trim().min(1, 'Identificação é obrigatória'),
});

export type MaintenanceSchemaType = z.infer<typeof MaintenanceSchema>;
